import React, { useCallback } from 'react';
import { Icon, Tappable } from '@vectord/components';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';

import {
  COURSE_PAUSE_RESCHEDULE_MODAL_STAGES,
  setCoursePauseRescheduleModalStage,
} from 'features/courseResume';
import styles from './UnscheduleRequestButton.module.scss';

function UnscheduleRequestButton() {
  const dispatch = useDispatch();

  const handleOnClick = useCallback(() => {
    dispatch(
      setCoursePauseRescheduleModalStage(
        COURSE_PAUSE_RESCHEDULE_MODAL_STAGES.unschedule
      )
    );
  }, [dispatch]);

  return (
    <Tappable
      onClick={handleOnClick}
      className={classNames(styles.root, 'btn btn-outlined btn-primary')}
    >
      <Icon
        name="close"
        className="m-r-xs"
      />
      Unschedule
    </Tappable>
  );
}

export default UnscheduleRequestButton;
